import { useMedia } from 'react-use';

import { tabletAndAbove } from 'style/mediaQuery';

export const useIsTabletAndAbove = () => useMedia(tabletAndAbove);
